import React from 'react'
import {connect} from 'react-redux'
import SelectBox from '../../../Expenses/common/SelectBox'

class CreditHistory extends React.Component {
  renderCreditHistory() {
    const { onClick, creditHistory, availableCreditHistory} = this.props

    return Object.values(availableCreditHistory).map((data) => (
      <div className='col-6 col-sm-3' key={ data.value }>
        <SelectBox
          name={'credit-history'}
          checked={ creditHistory === data.value }
          value={data.value}
          text={data.title}
          onChange={onClick}
        />
      </div>
    ))
  }

  render() {
    return (
      <div className='card card-single'>
        <div className='card-body'>
          <div className='qn'>Credit History</div>
          <div className='grey smaller mb-2'>How would you rate your credit history?</div>

          <div className='row no-gutters'>
            { this.renderCreditHistory() }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  availableCreditHistory: state.options.credit_history,
})

export default connect(mapStateToProps)(CreditHistory)
